(function(){
  'use strict';

  function cleanTitle(text){ return String(text || '').replace(/\s+—\s+.*$/,'').trim(); }
  function displayValue(value){ return String(value || '').trim().toLowerCase().replace(/\b\w/g,function(c){ return c.toUpperCase(); }).replace(/\bMm\b/g,'mm'); }

  function readProductData(){
    var node=document.querySelector('script[data-veyrissa-product-options-data]');
    if(!node) return null;
    try { return JSON.parse(node.textContent || '{}'); }
    catch(error){ return null; }
  }

  function isDefaultOnly(data){
    if(!data || !Array.isArray(data.options) || data.options.length!==1) return false;
    var option=data.options[0];
    var values=Array.isArray(option.values) ? option.values : [];
    return String(option.name || '').toLowerCase()==='title' && values.length===1 && String(values[0] || '').toLowerCase()==='default title';
  }

  function syncExisting(select, grid){
    select.hidden=true;
    select.setAttribute('aria-hidden','true');
    select.style.display='none';
    select.removeAttribute('name');
    grid.querySelectorAll('.veyrissa-variant-radio').forEach(function(radio){
      radio.checked=radio.value===select.value;
      if(radio.dataset.veyrissaVariantBound==='true') return;
      radio.dataset.veyrissaVariantBound='true';
      radio.addEventListener('change',function(){
        if(!radio.checked||radio.disabled)return;
        select.value=radio.value;
        select.dispatchEvent(new Event('change',{bubbles:true}));
      });
    });
  }

  function ensureChoiceLabel(wrap){
    if(wrap.querySelector(':scope > label, .veyrissa-single-option-label')) return;
    var label=document.createElement('div');
    label.className='veyrissa-single-option-label';
    label.textContent='CHOOSE YOUR OPTION';
    wrap.insertBefore(label,wrap.firstChild);
  }

  function buildSinglePicker(root, hidden, wrap){
    var data=readProductData();
    if(!data || isDefaultOnly(data) || !Array.isArray(data.variants) || !data.variants.length) return;
    var record=data.variants.find(function(variant){ return String(variant.id)===String(hidden.value); }) || data.variants[0];
    var title=record && Array.isArray(record.options) ? record.options.join(' / ') : '';
    if(!title) return;

    ensureChoiceLabel(wrap);
    var grid=document.createElement('div');
    grid.className='veyrissa-variant-grid is-single';
    grid.setAttribute('data-veyrissa-variant-grid','');

    var button=document.createElement('button');
    button.type='button';
    button.className='veyrissa-variant-option is-selected';
    button.setAttribute('aria-pressed','true');
    button.textContent=displayValue(title);
    button.disabled=record.available===false;
    grid.appendChild(button);
    hidden.insertAdjacentElement('afterend',grid);
  }

  function buildCombinedPicker(root, select, wrap){
    var existing=wrap.querySelector('[data-veyrissa-variant-grid]');
    if(existing){ syncExisting(select,existing); return; }

    var legacy=wrap.querySelector('.veyrissa-variant-grid');
    if(legacy) legacy.remove();

    select.hidden=true;
    select.setAttribute('aria-hidden','true');
    select.style.display='none';
    select.removeAttribute('name');

    var grid=document.createElement('div');
    grid.className='veyrissa-variant-grid';
    grid.setAttribute('data-veyrissa-variant-grid','');

    Array.prototype.forEach.call(select.options,function(option,index){
      var section=root.closest('.shopify-section');
      var id='VeyrissaVariant-'+(section ? section.id : 'product')+'-'+index;
      var radio=document.createElement('input');
      radio.type='radio';
      radio.name='id';
      radio.value=option.value;
      radio.id=id;
      radio.className='veyrissa-variant-radio';
      radio.disabled=option.getAttribute('data-available')!=='true';
      radio.checked=option.selected && !radio.disabled;

      var label=document.createElement('label');
      label.className='veyrissa-variant-option';
      label.setAttribute('for',id);
      label.textContent=cleanTitle(option.textContent);

      radio.addEventListener('change',function(){
        if(!radio.checked || radio.disabled) return;
        select.value=radio.value;
        select.dispatchEvent(new Event('change',{bubbles:true}));
      });

      grid.appendChild(radio);
      grid.appendChild(label);
    });

    select.insertAdjacentElement('afterend',grid);

    if(!grid.querySelector('.veyrissa-variant-radio:checked')){
      var first=grid.querySelector('.veyrissa-variant-radio:not(:disabled)');
      if(first){
        first.checked=true;
        select.value=first.value;
        select.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }

    select.addEventListener('change',function(){ syncExisting(select,grid); });
  }

  function enhanceRoot(root){
    if(!root) return;
    var wrap=root.querySelector('.product__option');
    if(!wrap) return;

    /* This enhancer owns the PDP option UI. Prevent the later script from splitting Color/Width. */
    root.dataset.v06VariantReady='true';

    var select=wrap.querySelector('select[data-variant-select]');
    if(select){
      buildCombinedPicker(root,select,wrap);
      return;
    }

    if(wrap.querySelector('[data-veyrissa-variant-grid]')) return;
    var hidden=wrap.querySelector('input[type="hidden"][name="id"]');
    if(hidden) buildSinglePicker(root,hidden,wrap);
  }

  function setTextIfNeeded(node,text){ if(node && node.textContent.trim()!==text) node.textContent=text; }

  function relabel(){
    document.querySelectorAll('[data-product-root]').forEach(function(root){
      enhanceRoot(root);
      root.setAttribute('data-add-label','Add to Bag');
      root.querySelectorAll('[data-atc-label]').forEach(function(node){
        if(!node.closest('button[disabled]')) setTextIfNeeded(node,'Add to Bag');
      });
    });
    document.querySelectorAll('.quick-add-dialog__submit:not([disabled]) span:first-child').forEach(function(node){
      setTextIfNeeded(node,'Add to Bag');
    });
  }

  var scheduled=false;
  function runSoon(){
    if(scheduled) return;
    scheduled=true;
    window.requestAnimationFrame(function(){ scheduled=false; relabel(); });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',relabel,{once:true});
  else relabel();
  document.addEventListener('shopify:section:load',runSoon);
  document.addEventListener('shopify:section:reorder',runSoon);

  var observer=new MutationObserver(function(records){
    for(var i=0;i<records.length;i++){
      if(records[i].addedNodes && records[i].addedNodes.length){ runSoon(); break; }
    }
  });
  if(document.documentElement) observer.observe(document.documentElement,{childList:true,subtree:true});
})();
